var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-menu',{staticClass:"pa-4",attrs:{"rounded":"lg","close-on-content-click":false},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-avatar',_vm._g(_vm._b({attrs:{"color":_vm.dark
            ? 'white'
            : 'grey lighten-2',"size":"45"}},'v-avatar',attrs,false),on),[_c('span',{staticClass:"grey--text text-h6"},[_vm._v(" "+_vm._s(_vm.initials)+" ")])])]}}])},[_vm._t("default")],2),_c('span',{class:_vm.dark
          ? 'pa-4 grey--text text--darken-2 text-menu'
          : 'pa-4 white--text text--darken-2 text-menu font-weight-bold'},[_vm._v(" "+_vm._s(_vm.username)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }